/**
 * Blocked Conversation Remapper
 * Flutter: lib/data/models/blocked_conversation.dart
 */
import type { BlockedConversationDto } from '@/data/dtos/blockedConversation/blockedConversationDto';
import type { JsonObject } from '@/data/types/json';
import type { BlockedConversationStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export class BlockedConversationRemapper {
  static toStorage(dto: BlockedConversationDto): BlockedConversationStorage {
    return {
      firebaseId: dto.firebaseId,
    };
  }

  static fromFirebaseId(firebaseId: string): BlockedConversationStorage {
    return {
      firebaseId,
    };
  }

  static fromJson(data: JsonObject): BlockedConversationDto {
    return {
      firebaseId: (data['firebaseId'] as string | undefined) ?? '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): BlockedConversationDto[] {
    return dataList.map(BlockedConversationRemapper.fromJson);
  }
}
